import { combineReducers } from "redux";
import { combineEpics } from "redux-observable";
import auth, { authEpic } from "reducers/auth";
import listPage from "reducers/listPage";
import parentMenu from "reducers/parentCrudMenu";
import nestedMenu from "reducers/nestedCrudMenu";
import brandSettings from "reducers/brandSettings";
import submitResponse from "./submitResponse";
import gateways from "./gateways";
import customFields from "reducers/customFields";
import workflowNotifications from "reducers/workflowNotifications";
import redirect from "reducers/redirect";
import roles from "reducers/roles";
import entity from "reducers/entity";

export const rootReducer = combineReducers({
  auth,
  listPage,
  parentMenu,
  nestedMenu,
  brandSettings,
  submitResponse,
  gateways,
  customFields,
  workflowNotifications,
  redirect,
  roles,
  entity,
});
export const rootEpic = combineEpics(authEpic);

export type Store = ReturnType<typeof rootReducer>;
